import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['name'];
  originalName = '';

  connect() {
    this.originalName ||= this.nameTarget.textContent;
  }

  changeHandler(event) {
    const file = event.target.files[0];
    this.nameTarget.textContent = file?.name || this.originalName;
  }
}
